const BASE_64_PREFIX = /^data:application\/pdf;base64,/;

export function validatePdfBase64String(file?: null | string): string | undefined {
  if (!file) {
    return undefined;
  }

  return BASE_64_PREFIX.test(file) ? file : `data:application/pdf;base64,${file}`;
}
